export enum UserClientFields {
    Id = "id",
    PersonTypeId = 'codPersonaTipo',
    PersonTypeDesc = 'descPersonaTipo',
    CompanyName = 'razonSocial',
    Name = 'nombre',
    Surname = 'apellido',
    IdentityDocumentTypeId = 'codDocumentoTipo',
    IdentityDocumentTypeDesc = 'descDocumentoTipo',
    IdentityDocumentNumber = 'numeroDocumento',
    Selected = 'seleccionado',
}

export interface UserClient {
    [UserClientFields.Id]: string;
    [UserClientFields.PersonTypeId]: number;
    [UserClientFields.PersonTypeDesc]: string;
    [UserClientFields.CompanyName]: string;
    [UserClientFields.Name]?: string | null;
    [UserClientFields.Surname]?: string | null;
    [UserClientFields.IdentityDocumentTypeId]: number;
    [UserClientFields.IdentityDocumentTypeDesc]: string;
    [UserClientFields.IdentityDocumentNumber]: string;
    [UserClientFields.Selected]: boolean;
}

export interface UserClientCreateUpdateDTO {
    [UserClientFields.PersonTypeId]: number;
    [UserClientFields.CompanyName]: string;
    [UserClientFields.Name]?: string | null;
    [UserClientFields.Surname]?: string | null;
    [UserClientFields.IdentityDocumentTypeId]: number;
    [UserClientFields.IdentityDocumentNumber]: string;
}














